
import { Steps } from 'antd';
import qs from 'qs';
import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from 'react-i18next';
import { RouteChildrenProps } from "react-router";
import {
    AutoRedirectAfterSubmitSuccessfully,
    AutoRefreshCalculationReportProcess, EcapReportGroupEnum,
    ReportTypeEnum,
    ReportAnalysisProcessEnum
} from '../../../../constants/constants';
import { ROUTE_PATHS } from '../../../../constants/url-config';
import { BRResultDataModel, EcapReportModel, ECAPResourseModel as ECAPResourceModel, ORInputDataModel, ResultDataModel } from '../../../../models/ecap-report.model';
import { ECAPService } from '../../../../services/ecap.service';
import { AMOUNT_UTIL } from '../../../../utils/amount.utils';
import i18n from '../../../../utils/i18n';
import { PaperIcon, PaperPlusIcon, PaperUploadIcon, TickSquareIcon } from '../../../atoms/icon';
import OROutput from '../shared/or-output/or-output';
import BRInput from './br-input';
import MRInput from './mr-input';
import "./new-report.scss";
import ORInput from './or-input';
import SelectPeriod from './select-period';
import Submited from './submited';
import UploadFile from './upload-file';
import ViewResult from './view-result';
import BrOutput from '../shared/br-output';


export interface ECapReportStepProps {
    next?: (values?: EcapReportModel, file_index?: number) => void;
    goback?: () => void;
    caculating?: boolean;
    risk_type?: ReportTypeEnum;
    outputData?: ResultDataModel[];
    fileIndex?: number;
    created_on?: string;
    resources?: ECAPResourceModel;
    orOutput?: ORInputDataModel;
    title?: string;
    brOutput?: BRResultDataModel[];
}

interface ReportStepModel {
    title?: string,
    icon?: JSX.Element,
    content: (props: ECapReportStepProps) => JSX.Element,
    fileIndex?: number;
    isFileUpload?: boolean;
    isCreateReportStep?: boolean;
    isViewResultStep?: boolean;
}

const COMMON_STEPS: ReportStepModel[] = [{
    title: i18n.t("RapmReport.stepTitleSelectPeriod"),
    icon: <TickSquareIcon />,
    content: SelectPeriod
},
{
    title: i18n.t("RapmReport.stepTitleUploadCSVFile"),
    icon: <PaperPlusIcon />,
    content: UploadFile,
    isFileUpload: true,
    isCreateReportStep: true
},
{
    title: i18n.t("RapmReport.stepTitleViewResult"),
    icon: <PaperIcon />,
    content: ViewResult,
    isViewResultStep: true
},
{
    title: i18n.t("RapmReport.stepTitleSubmitForApproval"),
    icon: <PaperUploadIcon />,
    content: Submited
}]

const IRR_STEPS: ReportStepModel[] = [{
    title: i18n.t("RapmReport.stepTitleSelectPeriod"),
    icon: <TickSquareIcon />,
    content: SelectPeriod
},
{
    title: i18n.t("EcapModule.ttUploadCSVRates"),
    icon: <PaperPlusIcon />,
    content: UploadFile,
    fileIndex: 0,
    isFileUpload: true
}, {
    title: i18n.t("EcapModule.ttUploadCSVBalanceSheet"),
    icon: <PaperPlusIcon />,
    content: UploadFile,
    fileIndex: 1,
    isFileUpload: true,
    isCreateReportStep: true
},
{
    title: i18n.t("RapmReport.stepTitleViewResult"),
    icon: <PaperIcon />,
    content: ViewResult,
    isViewResultStep: true
},
{
    title: i18n.t("RapmReport.stepTitleSubmitForApproval"),
    icon: <PaperUploadIcon />,
    content: Submited
}]

const OR_STEPS: ReportStepModel[] = [{
    title: i18n.t("RapmReport.stepTitleSelectPeriod"),
    icon: <TickSquareIcon />,
    content: SelectPeriod
},
{
    title: i18n.t("EcapModule.stepTitleInput"),
    icon: <PaperPlusIcon />,
    content: ORInput,
    isCreateReportStep: true
},
{
    title: i18n.t("RapmReport.stepTitleViewResult"),
    icon: <PaperIcon />,
    content: OROutput,
    isViewResultStep: true
},
{
    title: i18n.t("RapmReport.stepTitleSubmitForApproval"),
    icon: <PaperUploadIcon />,
    content: Submited
}]

const BR_STEPS: ReportStepModel[] = [{
    title: i18n.t("RapmReport.stepTitleSelectPeriod"),
    icon: <TickSquareIcon />,
    content: SelectPeriod
},
{
    title: i18n.t("EcapModule.stepTitleInput"),
    icon: <PaperPlusIcon />,
    content: BRInput,
    isCreateReportStep: true
},
{
    title: i18n.t("RapmReport.stepTitleViewResult"),
    icon: <PaperIcon />,
    content: BrOutput,
    isViewResultStep: true
},
{
    title: i18n.t("RapmReport.stepTitleSubmitForApproval"),
    icon: <PaperUploadIcon />,
    content: Submited
}]

const MR_STEPS: ReportStepModel[] = [{
    title: i18n.t("RapmReport.stepTitleSelectPeriod"),
    icon: <TickSquareIcon />,
    content: SelectPeriod
},
{

    title: i18n.t("EcapModule.ttInputInformation"),
    icon: <PaperPlusIcon />,
    content: MRInput,
    isFileUpload: true
},
//  {

//     title: i18n.t("EcapModule.ttInvestments"),
//     icon: <PaperPlusIcon />,
//     content: MRInvestments,
// },
{
    title: i18n.t("EcapModule.ttUploadNAVValues"),
    icon: <PaperPlusIcon />,
    content: UploadFile,
    isFileUpload: true,
    fileIndex: 1
},
{
    title: i18n.t("EcapModule.ttUploadIncomeValues"),
    icon: <PaperPlusIcon />,
    content: UploadFile,
    isFileUpload: true,
    fileIndex: 2,
    isCreateReportStep: true
},
{
    title: i18n.t("RapmReport.stepTitleViewResult"),
    icon: <PaperIcon />,
    content: ViewResult,
    isViewResultStep: true
},
{
    title: i18n.t("RapmReport.stepTitleSubmitForApproval"),
    icon: <PaperUploadIcon />,
    content: Submited
}]



const { Step } = Steps;
interface Props extends RouteChildrenProps<{ id: string }> { }

const EcapNewReport = (props: Props) => {
    const [currentStep, setCurrentStep] = useState(0);
    const [caculating, setCaculating] = useState(false);
    const model = useRef<EcapReportModel>({});
    const [outputData, setOutputData] = useState<any[]>([]);
    const getReportInterval = useRef<NodeJS.Timeout>();
    const group = useRef<EcapReportGroupEnum>();
    const [steps, setSteps] = useState<ReportStepModel[]>([]);
    const [resources, setResources] = useState<ECAPResourceModel>({});
    const [orOutput, setOrOutput] = useState<ORInputDataModel>({});
    const [brOutput, setBrOutput] = useState<BRResultDataModel[]>([]);
    const { t } = useTranslation();

    const next = (values?: EcapReportModel, file_index: number = 0) => {

        const stepItem = steps[currentStep];
        if (!stepItem) {
            return;
        }

        if (values) {

            if (stepItem.isFileUpload) {
                if (!model.current.data_file_ids_tmp) {
                    model.current.data_file_ids_tmp = [];
                }

                const currentFile = model.current.data_file_ids_tmp.find(x => x.index === file_index);
                if (currentFile) {
                    currentFile.file_ids = values.data_file_ids;
                } else {
                    model.current.data_file_ids_tmp.push({
                        index: file_index,
                        file_ids: values.data_file_ids
                    });
                }

            } else {
                model.current = { ...model.current, ...values };
            }
        }


        if (stepItem.isCreateReportStep) {

            switch (model.current.risk_type) {
                case ReportTypeEnum.OperationalRisk:
                    ECAPService.createOperationRisk(model.current).then(res => {
                        model.current.id = res.data.id;
                        inintOROutPut(res.data);
                        setCurrentStep(pre => pre + 1);
                        props.history.push(`${ROUTE_PATHS.ECAPNewReport}?type=${model.current.risk_type}&group=${group.current}&id=${res.data.id}`);
                    })
                    break;
                case ReportTypeEnum.BusinessRisk:
                    ECAPService.createBusinessRisk(model.current).then(res => {
                        model.current.id = res.data.id;
                        inintBROutPut(res.data);
                        setCurrentStep(pre => pre + 1);
                        props.history.push(`${ROUTE_PATHS.ECAPNewReport}?type=${model.current.risk_type}&group=${group.current}&id=${res.data.id}`);
                    })
                    break;

                default:
                    if (model.current.data_file_ids_tmp && model.current.data_file_ids_tmp.length) {
                        model.current.data_file_ids = [];
                        model.current.data_file_ids_tmp.forEach(res => {
                            if (res.file_ids) {
                                model.current.data_file_ids = model.current.data_file_ids?.concat(res.file_ids);
                            }
                        });
                    }

                    ECAPService.createEcapReport(model.current).then(res => {
                        model.current.id = res.data.id;
                        model.current.job_id = res.data.job_id;

                        if (model.current.risk_type === ReportTypeEnum.Ramp) {
                            props.history.push(`${ROUTE_PATHS.PortfolioRAROCNewReport}?&id=${res.data.id}&job_id=${model.current.job_id}&process_state=${ReportAnalysisProcessEnum.Processing}`);
                        } else {
                            props.history.push(`${ROUTE_PATHS.ECAPNewReport}?type=${model.current.risk_type}&group=${group.current}&id=${res.data.id}&job_id=${model.current.job_id}&process_state=${ReportAnalysisProcessEnum.Processing}`);
                        }
                        calculationProcess();
                    })
                    break;
            }

        } else if (stepItem.isViewResultStep) {
            if (model.current.id) {
                ECAPService.submitEcapReportForApproval(model.current).then(res => {
                    setCurrentStep(pre => pre + 1);
                    setTimeout(() => {
                        if (model.current.risk_type === ReportTypeEnum.Ramp) {
                            props.history.push(ROUTE_PATHS.PortfolioRAROCModule);
                        } else {
                            props.history.push(`${ROUTE_PATHS.ECAPReports}?type=${model.current.risk_type}&group=${group.current}`);
                        }
                    }, AutoRedirectAfterSubmitSuccessfully)
                });
            }
        } else {
            setCurrentStep(pre => pre + 1);
        }
    }

    const goback = () => {
        setCurrentStep(pre => pre - 1)
    }

    const calculationProcess = () => {
        setCaculating(true);
        getReportInterval.current = setInterval(() => {
            getReportDetails();
        }, AutoRefreshCalculationReportProcess)
    }

    const inintOROutPut = (data: any) => {
        if (!data.result_data || !data.result_data.length) {
            return;
        }

        const result_data = data.result_data[0] as ORInputDataModel;

        result_data.risk_weighted_equivalents?.map(item => {

            if (data.input_data && data.input_data.length) {
                const input_data = data.input_data[0] as ORInputDataModel;
                const net = input_data.net_interest_incomes?.find(p => p.year === item.year);
                if (net) {
                    item.net_interest_income = net?.value;
                }
            }

            return item;
        })

        setOrOutput(result_data);
    }

    const inintBROutPut = (data: any) => {
        if (!data.result_data || !data.result_data.length) {
            return;
        }

        setBrOutput([{
            Name: t("EcapModule.lbDesiredRatingLevel"),
            Values: data.result_data[0].target_rating
        },
        {
            Name: t("EcapModule.lbCapitalRequired"),
            Values: AMOUNT_UTIL.convertNumericToFormattedAmount(data.result_data[0].capital_required)
        }]);
    }

    const getReportDetails = () => {
        if (model.current.id) {
            ECAPService.getEcapReportDetails(model.current.id, false, model.current.job_id).then(res => {

                model.current.created_on = res.data.created_on;
                if (model.current.risk_type === ReportTypeEnum.OperationalRisk) {
                    inintOROutPut(res.data);
                } else if (model.current.risk_type === ReportTypeEnum.BusinessRisk) {
                    inintBROutPut(res.data);
                } else {
                    model.current.submit_state = res.data.submit_state;
                    model.current.dataset_id = res.data.dataset_id;
                    if (res.data.process_state === ReportAnalysisProcessEnum.Processed) {
                        if (getReportInterval.current) {
                            clearInterval(getReportInterval.current);
                            setCaculating(false);
                            setCurrentStep(pre => pre + 1);

                        }
                        setOutputData(res.data.result_data);
                    }
                }

            })
        }
    }

    const stepIconClick = (index: number) => {
        if (index < currentStep) {
            if (getReportInterval.current) {
                clearInterval(getReportInterval.current);
                setCaculating(false);
            }
            setCurrentStep(index);
        }
    }

    useEffect(() => {

        const query = qs.parse(props.location.search, { ignoreQueryPrefix: true });
        if (Number(query.id)) {
            model.current.id = Number(query.id);
        }

        if (props.location.pathname === ROUTE_PATHS.PortfolioRAROCNewReport) {
            model.current.risk_type = ReportTypeEnum.Ramp;
        } else {
            model.current.risk_type = query.type as ReportTypeEnum;
        }

        model.current.job_id = query.job_id?.toString();
        group.current = Number(query.group) as EcapReportGroupEnum;

        let tmpSteps: ReportStepModel[] = [];

        switch (model.current.risk_type) {
            case ReportTypeEnum.InterestRateRisk:
                tmpSteps = IRR_STEPS;
                break;
            case ReportTypeEnum.OperationalRisk:
                tmpSteps = OR_STEPS;
                break;
            case ReportTypeEnum.MarketRisk:
                tmpSteps = MR_STEPS;
                break;
            case ReportTypeEnum.BusinessRisk:
                tmpSteps = BR_STEPS;
                break;
            default:
                tmpSteps = COMMON_STEPS;
                break;
        }

        setSteps(tmpSteps);

        if (!Object.values(ReportTypeEnum).includes(model.current.risk_type)) {
            props.history.push(ROUTE_PATHS.Home); // navigate 404 page
        } else {

            const process_state = query.process_state?.toString();

            // continue proccess
            if (model.current.id) {

                if (process_state === ReportAnalysisProcessEnum.Processing) {
                    const i = tmpSteps.findIndex(p => p.isCreateReportStep);
                    setCurrentStep(i);
                    calculationProcess();
                } else {
                    const i = tmpSteps.findIndex(p => p.isViewResultStep);
                    setCurrentStep(i);
                }

                getReportDetails();
            }

            ECAPService.getResources().then(res => {
                setResources(res.data);
            })

        }


        return (() => {
            if (getReportInterval.current) {
                clearInterval(getReportInterval.current);
            }
        })
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return (
        <div className="ecap-new-wrapper">
            <div className='ecap-form-wrapper'>
                <div className="step-wrapper">

                    <Steps current={currentStep} labelPlacement="vertical">
                        {
                            steps && steps.map((item, index) => (
                                <Step className={`${index <= currentStep ? "active" : ""}`} key={index} title={item.title} icon={item.icon} onClick={() => stepIconClick(index)} />
                            ))
                        }
                    </Steps>
                </div>

                {
                    steps && steps.map((item, index) => (
                        <div key={index} className={currentStep === index ? "" : "hidden"}>
                            <item.content
                                next={next}
                                outputData={outputData}
                                risk_type={model.current.risk_type}
                                caculating={caculating}
                                fileIndex={item.fileIndex}
                                created_on={model.current.created_on}
                                resources={resources}
                                orOutput={orOutput}
                                goback={goback}
                                title={item.title}
                                brOutput={brOutput}
                            />
                        </div>
                    ))
                }

            </div>
        </div>
    )
}

export default EcapNewReport;